module.exports = __webpack_public_path__ + "static/media/messenger.d71cc566.svg";